export enum PackagedInsightAiMetadataAttributes {
    DECK_SIZE = "deckSize",
}

export enum PackagedInsightAiDeckSize {
    FULL_LENGTH = "FULL_LENGTH",
}
